export default __webpack_public_path__ + "static/Calendar-2011-15-1445a4547be79bcc4eea7d5a3ca1b9b7.jpg";